import styled from '@emotion/styled';

export const SContainer = styled.div``;

export const SFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SSelectOption = styled.div`
  display: flex;
  gap: 8px;
`;
